import React from 'react'

// Sanitize text to remove line breaks and multiple spaces
const sanitizeText = (text: string): string => {
  return text
    .replace(/\n/g, ' ') // replace line breaks with spaces
    .replace(/\s+/g, ' ') // replace multiple spaces with one
    .trim()
}

// Extract and sanitize all text from React children, this method is adapted to respect the max number of statements per function
const extractText = (node: React.ReactNode): string => {
  if (typeof node === 'string') {
    return node
  }

  if (Array.isArray(node)) {
    return node.map(extractText).join(' ')
  }

  return React.isValidElement(node) ? extractText(node.props.children) : ''
}

// Check recursively if any child contains a line break, same here about the max number of statements per function
const hasLineBreak = (node: React.ReactNode): boolean => {
  if (typeof node === 'string') {
    return node.includes('\n')
  }

  if (Array.isArray(node)) {
    return node.some(hasLineBreak)
  }

  return React.isValidElement(node) ? hasLineBreak(node.props.children) : false
}

export { sanitizeText, extractText, hasLineBreak }
